import { getSystemBasicConfig } from '@/api/system'

const DEFAULT_PAGE_SIZE_KEY = 'system_default_page_size'

function applyDocumentTitle(systemName) {
  document.title = systemName || '管理后台'
}

function getStoredDefaultPageSize() {
  const value = Number(window.localStorage.getItem(DEFAULT_PAGE_SIZE_KEY) || 10)
  return Number.isFinite(value) && value > 0 ? value : 10
}

const state = {
  systemName: '管理后台',
  systemLogo: '',
  description: '',
  defaultPageSize: getStoredDefaultPageSize(),
  configLoaded: false
}

const mutations = {
  SET_CONFIG(state, config) {
    state.systemName = config.system_name || '管理后台'
    state.systemLogo = config.system_logo || ''
    state.description = config.description || ''
    state.defaultPageSize = Number(config.default_page_size) > 0 ? Number(config.default_page_size) : 10
    state.configLoaded = true
    window.localStorage.setItem(DEFAULT_PAGE_SIZE_KEY, String(state.defaultPageSize))
    applyDocumentTitle(state.systemName)
  }
}

const actions = {
  fetchConfig({ commit }) {
    return getSystemBasicConfig().then(config => {
      commit('SET_CONFIG', config)
      return config
    })
  },
  applyConfig({ commit }, config) {
    commit('SET_CONFIG', config)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
